import * as moment from 'moment';
import type { ICMSContentTemplatesDatasource } from './base/cmsdatasource';
import { expressionBuilder, IExpressionBuilderPredicates } from '@inwink/expressions/expressionbuilder';
import type { Entities } from '@inwink/entities/entities';

export function getTemplates(
    datasource: ICMSContentTemplatesDatasource,
    application,
    state,
    type,
    tinyurl,
    groupId?,
    singleTemplate?: boolean
): Promise<Entities.IContentTemplateBase<any> | Entities.IContentTemplateBase<any>[]> {
    const filters: IExpressionBuilderPredicates = [];
    if (application) {
        filters.push((e) => e.WithString("application").Equals(application));
    }
    if (state) {
        filters.push((e) => e.WithString("state").Equals(state));
    }
    if (type) {
        filters.push((e) => e.WithString("contentType").Equals(type));
    }
    if (tinyurl) {
        filters.push((e) => e.WithString("tinyUrl").Equals(tinyurl));
    }
    if (groupId) {
        filters.push((e) => e.WithString("groupId").Equals(groupId));
    }
    const options = {
        filters: expressionBuilder((e) => e.And(filters))
    };
    return new Promise((resolve, reject) => {
        datasource.query(options)
            .then((res) => {
                if (res && res.data && res.data.length) {
                    resolve(singleTemplate ? res.data[0] : res.data);
                } else {
                    resolve(null);
                }
            }).catch((err) => reject(err));
    });
}

export function setDisabled(datasource: ICMSContentTemplatesDatasource, id: string, disabled: boolean) {
    const entity = {
        id,
        disabled
    };
    return datasource.update(entity);
}

export function listTemplates(datasource: ICMSContentTemplatesDatasource,
    application, state, lastSync?: Date): Promise<Entities.IContentTemplateBase<any>[]> {
    const filters: IExpressionBuilderPredicates = [];
    if (lastSync && moment(lastSync).isValid()) {
        filters.push((e) => e.WithDate("validfrom").GreaterThanOrEqual(moment(lastSync)));
    }
    filters.push((e) => e.WithString("application").Equals(application));
    filters.push((e) => e.WithString("state").Equals(state));

    return datasource.query({
        filters: expressionBuilder((e) => e.And(filters)),
        selects: {
            $all: true
        }
    }).then((result) => result.data);
}

export function deleteTemplate(
    datasource: ICMSContentTemplatesDatasource,
    template: { id: string; tinyUrl?: string; application?: string; contentType?: string; state?: string }
) {
    return datasource.delete([template.id]).then(() => {
        // Si le template supprimé était en preview, chercher et supprimer la version published
        if (template?.state === "preview" && template.tinyUrl && template.application && template.contentType) {
            return datasource.query({
                filters: {
                    $and: [
                        { tinyUrl: template.tinyUrl },
                        { application: template.application },
                        { contentType: template.contentType },
                        { state: 'published' }
                    ]
                },
                selects: { id: true }
            }).then((res) => {
                const publishedTemplate = res?.data?.[0];
                if (publishedTemplate) {
                    return datasource.delete([publishedTemplate.id]);
                }
                return Promise.resolve();
            });
        }
        return Promise.resolve();
    });
}

export function deleteTemplateByIds(datasource: ICMSContentTemplatesDatasource, templateIds: string[]) {
    return datasource.delete([...templateIds]);
}
